import { render, staticRenderFns } from "./CategoryItems.vue?vue&type=template&id=5455226b"
import script from "@/controllers/custom/library/category-items.js?vue&type=script&lang=js&external"
export * from "@/controllers/custom/library/category-items.js?vue&type=script&lang=js&external"
import style0 from "./CategoryItems.vue?vue&type=style&index=0&id=5455226b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports